import { Errors, Form, UpdateForm } from '..'
import InputDate from 'components/inputs/Date'
import React from 'react'

interface DataProps {
  form: Form
  errors: Errors
  updateForm: UpdateForm
  validate: () => void
}

const Data: React.FC<DataProps> = ({form, errors, updateForm, validate}) => {
  const handleChange: UpdateForm = (key, value) => {
    updateForm(key, value)
    if (errors[key as keyof Errors]) {
      validate()
    }
  }

  return (
    <>
      <div className='infoLabel'>
        Wypełnij podstawowe dane
      </div>
      
      <div className='myInput'>
        <label>{errors.name || 'Imię i nazwisko'}</label>
        <input
          className={errors.name ? 'error' : ''}
          type='text'
          placeholder='Wpisz imię i nazwisko'
          value={form.name}
          onChange={(e) => {
            handleChange('name', e.target.value)
          }}
        />
      </div>

      <InputDate
        value={form.birth}
        onChange={(date) => {
          handleChange('birth', date)
        }}
        label={errors.birth || 'Data urodzenia'}
        error={errors.birth}
      />

      <InputDate
        value={form.death}
        onChange={(date) => {
          handleChange('death', date)
        }}
        label={errors.death || 'Data śmierci'}
        error={errors.death}
        today
      />
    </>
  )
}

export default Data